<template>
    <div>
        <div class="main">
            <div class="search-c">
                <el-button size="small" class="btnBgColor_blue_empty_no" @click="add">+ 新增</el-button>
            </div>
            <div class="table_wrap height">
                <el-table key="one" :data="list" v-loading="loading" style="width: 100%" height="100%" header-cell-class-name="table-header" cell-class-name="cell-class">
                    <template slot="empty">
                        <empty-data img='no_img_b.png' text='暂无数据'></empty-data>
                    </template>
                    <el-table-column prop="name" align="center" label="套餐名称">
                    </el-table-column>
                    <el-table-column prop="original_price" label="原价(元)">
                    </el-table-column>
                    <el-table-column prop="current_price" label="现价(元)">
                    </el-table-column>
                    <el-table-column prop="diamond" label="支付钻石(钻)" width="120">
                    </el-table-column>
                    <el-table-column prop="youhui" label="优惠钻石(钻)" width="120">
                    </el-table-column>
                    <el-table-column prop="data4" label="权益" width="400">
                        <template slot-scope="scope">
                            <p style="line-height: 20px;padding-top: 6px;" v-for="item,index in scope.row.rights_two" :key="index">{{item.product_name}}({{item.valid_text}})</p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="data5" label="状态">
                        <template slot-scope="scope">
                            <el-switch :key="scope.row.id" v-model="scope.row.status" :active-value="1" :inactive-value="2" @change="changeSwitch($event,scope.row)"></el-switch>
                        </template>
                    </el-table-column>
                    <el-table-column prop="create_time" label="创建时间" width="180">
                    </el-table-column>
                    <el-table-column prop="update_time" label="更新时间" width="180">
                    </el-table-column>
                    <el-table-column label="操作" fixed="right" width="100">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="edit(scope.row)">
                                编辑
                            </el-button>
                            <el-button type="text" size="small" @click="del(scope.row)">
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="page_box pr20">
                <paging-page :total='total' align='right' @sizeChange='sizeChangeBtn' @currentChange='currentChangeBtn'></paging-page>
            </div>
        </div>
        <!-- 删除 -->
        <point-out ref='dialogTip' @close='closeBtn' type='accountDel' dialogTitle="提示" dialogWidth='400px' :iconShow='true' iconColor='#FF7432' borderRadius='10px' :cancelShow='true' :affirmShow='true'>
            <div class="zc_dialog_tip_content">
                <div class="text">删除后该{{name}}不会再显示在云川平台上，您确定要删除该{{name}}吗？</div>
            </div>
        </point-out>
        <add-member ref='addmember' :cardTypeList="cardTypeList" :dateValidList="dateValidList" @getList="getList"></add-member>
    </div>
</template>

<script>
import EmptyData from '@/components/empty_data/empty_data.vue'//空数据
import PagingPage from '@/components/paging_page/paging_page.vue'//分页
import PointOut from '@/components/point_out/point_out.vue'
import AddMember from '../components/addMember.vue'
export default {
    components: { EmptyData, PagingPage, PointOut, AddMember },
    props: {
        dateValidList: Array,
        cardTypeList: Array,
    },
    data() {
        return {
            page: 1,
            limit: 10,
            total: 0,
            loading: false,
            list: [],
            name: '',
            id: '',
        };
    },
    created() {
        this.getList()
    },
    mounted() {

    },
    methods: {
        add() {
            this.$refs.addmember.open()
        },
        edit(val) {
            this.$refs.addmember.open(val)
        },
        getList() {
            let obj = {
                page: this.page,
                limit: this.limit,
            }
            this.loading = true
            this.$setupApi.memberList(obj).then(res => {
                this.loading = false
                if (res.code == 1000) {
                    let arr = res.result.data
                    arr.forEach(ele => {
                        ele.rights_two = Object.values(ele.rights)
                    })
                    this.list = arr
                    this.total = res.result.total

                } else {
                    this.$errMsg(res.message)
                }
            })
        },
        // 删除
        closeBtn() {
            console.log('删除')
            this.$setupApi.memberDel(this.id).then(res => {
                if (res.code == 1000) {
                    this.$succMsg(res.message)
                    this.getList()
                } else {
                    this.$errMsg(res.message)
                }
            })
        },
        // 删除提示
        del(val) {
            this.id = val.id;
            this.name = val.name;
            this.$refs.dialogTip.openDialogBtn()
        },
        // 开关状态修改
        changeSwitch(status, val) {
            let obj = {
                status: status,
                id: val.id
            }
            this.$setupApi.memberConfigStatus(obj).then(res => {
                if (res.code == 1000) {
                    this.$succMsg('状态修改成功')
                } else {
                    this.$errMsg(res.message)
                }
            })
        },
        sizeChangeBtn(val) {
            this.limit = val
            this.page = 1
            this.getList();
        },
        currentChangeBtn(val) {
            this.page = val;
            this.getList();
        },
    },
};
</script>

<style scoped lang="scss">
@import "./index.scss";
.height {
    height: calc(100vh - 320px);
}
</style>
